import { render, staticRenderFns } from "./vehicleInfo.vue?vue&type=template&id=be9f4c44&scoped=true&"
import script from "./vehicleInfo.vue?vue&type=script&lang=js&"
export * from "./vehicleInfo.vue?vue&type=script&lang=js&"
import style0 from "./vehicleInfo.vue?vue&type=style&index=0&id=be9f4c44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9f4c44",
  null
  
)

export default component.exports